import moment from "moment";
import React, { useState } from "react";
import ImageViewModal from "../modals/image-view/image-view-modal";
import OrdersHistoryModal from "../modals/order-view-modals/orderHistoryModal";

const OrderHistoryTableData = ({ data, index, currentPage }) => {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [imageTitleData, setImageTitleData] = useState("");
  const [imageUrlData, setImageUrlData] = useState("");
  const [multiImageUrlData, setMultiImageUrlData] = useState([]);
  const array = [
    "fully_invoiced",
    "partially_invoiced",
    "acknowledged",
    "partially_acknowledged",
  ];
  return (
    <tr className="table-rows1" key={data?.id}>
      <td className="main-table-each-row-data">{index + 1}</td>
      <td className="main-table-each-row-data">
        {data?.order_id ? data?.order_id : "--"}
      </td>
      <td className="main-table-each-row-data">
        {data?.createdAt
          ? moment(data?.createdAt).format("DD MMM YYYY, HH:mm A").toUpperCase()
          : "--"}
      </td>
      <td className="main-table-each-row-data">
        {data.invoices[0]?.invoice_id ? data.invoices[0]?.invoice_id : "--"}
      </td>
      <td className="main-table-each-row-data">
        {data?.updatedAt
          ? moment(data?.updatedAt).format("DD MMM YYYY, HH:mm A").toUpperCase()
          : "--"}
      </td>
      <td className="main-table-each-row-data">
        {data?.vendorDivision?.name ? data?.vendorDivision?.name : "--"}
      </td>
      <td className="main-table-each-row-data">
        {data?.doctor?.name ? data?.doctor?.name : "--"}
      </td>
      <td className="main-table-each-row-data">
        {data?.pharmacy_id
          ? data?.pharmacy?.pharmacy_name
          : data?.doctor?.pharmacy_type == "attach"
          ? data?.doctor?.doctorAttachPharmacy?.pharmacy?.pharmacy_name
          : data?.doctor?.pharmacy_type == "self"
          ? data?.doctor?.doctorSelfPharmacy?.pharmacy_name
          : (data?.doctor?.pharmacy_type == "dispensing" && "Dispensing") ||
            "--"}
      </td>
      {/* <td
        className={`main-table-each-row-data ${ReimbursementstatusColor(
          "data.ReimbursementStatus"
        )}`}
      >
        {"data.ReimbursementStatus"}
      </td> */}
      <td className="main-table-each-row-data">
        <span
          className={`${
            orderStatus.find((e) => e?.status == data?.status)?.color
          }`}
        >
          {orderStatus.find((e) => e?.status == data?.status)?.value}
        </span>
      </td>
      <td
        className="main-table-each-row-data text-truncate"
        title={data?.rejectionReason?.title}
        style={{ maxWidth: "150px" }}
      >
        {data?.rejectionReason?.title ? data?.rejectionReason?.title : "--"}
      </td>
      <td className="main-table-each-row-data d-flex align-items-center">
        <label
          className="color_2ad3e7 fw_700 mx-2 fs_14 cursor_pointer"
          onClick={() => setShowDetailModal(true)}
        >
          VIEW
        </label>
        <span className="vr_line mx-1 color_b0b3c7 "></span>

        <button
          className="Medium_Purple fw_600 cursor_pointer action-btn"
          disabled={!array.some((item) => item == data?.status)}
          onClick={() => {
            setImageModal(true);
            setImageUrlData(data?.invoices[0]?.url);
            setMultiImageUrlData(data?.invoices);
          }}
        >
          INVOICE IMAGE
        </button>
      </td>
      <OrdersHistoryModal
        Show={showDetailModal}
        ShowClose={() => setShowDetailModal(false)}
        id={data?.id}
      />
      <ImageViewModal
        show={imageModal}
        ShowClose={() => setImageModal(false)}
        imageTitleData={imageTitleData}
        imageUrlData={imageUrlData}
        muliImageData={multiImageUrlData}
        setImageUrlData={setImageUrlData}
      />
    </tr>
  );
};

export default OrderHistoryTableData;

export const orderStatus = [
  { status: "pending", value: "Approval Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Hold", color: "text-danger" },
];
